/* Reeyah's — display currency converter
   Shows prices in the visitor's local currency (auto-detected via
   Shopify.country, manually switchable). Display only: checkout is
   processed in NGN, stated in the switcher UI. */
(function () {
  'use strict';

  var BASE = 'NGN';
  var STORE_KEY = 'rhp_currency';
  var RATES_KEY = 'rhp_currency_rates_v1';
  var RATES_TTL_MS = 12 * 60 * 60 * 1000;
  var RATES_URL = 'https://open.er-api.com/v6/latest/NGN';

  var CURRENCIES = {
    NGN: { symbol: '₦', suffix: ' NGN', name: 'Nigerian Naira' },
    GBP: { symbol: '£', suffix: '', name: 'British Pound' },
    USD: { symbol: '$', suffix: '', name: 'US Dollar' },
    GHS: { symbol: 'GH₵', suffix: '', name: 'Ghanaian Cedi' },
    CAD: { symbol: 'CA$', suffix: '', name: 'Canadian Dollar' }
  };

  var COUNTRY_TO_CURRENCY = { NG: 'NGN', GB: 'GBP', US: 'USD', GH: 'GHS', CA: 'CAD' };

  /* Approximate fallbacks, replaced by live rates on first successful fetch */
  var FALLBACK_RATES = { NGN: 1, GBP: 0.00051, USD: 0.00065, GHS: 0.0071, CAD: 0.0009 };

  var state = { currency: BASE, rates: FALLBACK_RATES };
  var MONEY_RE = /₦\s?([\d,]+(?:\.\d{1,2})?)(\s*NGN)?/;

  function detectCurrency() {
    try {
      var saved = localStorage.getItem(STORE_KEY);
      if (saved && CURRENCIES[saved]) return saved;
    } catch (e) {}
    var country = (window.Shopify && window.Shopify.country) || '';
    return COUNTRY_TO_CURRENCY[country] || BASE;
  }

  function loadRates(cb) {
    try {
      var cached = JSON.parse(localStorage.getItem(RATES_KEY) || 'null');
      if (cached && cached.ts && Date.now() - cached.ts < RATES_TTL_MS && cached.rates) {
        state.rates = cached.rates;
        cb();
        return;
      }
    } catch (e) {}
    var done = false;
    var timer = setTimeout(function () { if (!done) { done = true; cb(); } }, 4000);
    fetch(RATES_URL)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.result === 'ok' && data.rates) {
          var rates = { NGN: 1 };
          Object.keys(CURRENCIES).forEach(function (c) {
            if (data.rates[c]) rates[c] = data.rates[c];
          });
          state.rates = rates;
          try { localStorage.setItem(RATES_KEY, JSON.stringify({ ts: Date.now(), rates: rates })); } catch (e) {}
        }
      })
      .catch(function () {})
      .then(function () {
        clearTimeout(timer);
        if (!done) { done = true; cb(); }
      });
  }

  function parseAmount(str) {
    return parseFloat(str.replace(/,/g, ''));
  }

  function formatMoney(ngnAmount, code, hadSuffix) {
    var cur = CURRENCIES[code];
    if (code === BASE) {
      var whole = ngnAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return cur.symbol + whole + (hadSuffix ? cur.suffix : '');
    }
    var value = ngnAmount * (state.rates[code] || FALLBACK_RATES[code]);
    var formatted = value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return cur.symbol + formatted;
  }

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, TEMPLATE: 1 };

  function wrapMoneyNodes(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentElement;
        if (!p || SKIP_TAGS[p.tagName]) return NodeFilter.FILTER_REJECT;
        if (p.closest('.rhp-money, .rhp-cur, [data-rhp-no-convert]')) return NodeFilter.FILTER_REJECT;
        return MONEY_RE.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(function (textNode) {
      var text = textNode.nodeValue;
      var frag = document.createDocumentFragment();
      var rest = text;
      var m;
      while ((m = rest.match(MONEY_RE))) {
        var idx = m.index;
        if (idx > 0) frag.appendChild(document.createTextNode(rest.slice(0, idx)));
        var span = document.createElement('span');
        span.className = 'rhp-money';
        span.setAttribute('data-ngn', String(parseAmount(m[1])));
        span.setAttribute('data-suffix', m[2] ? '1' : '0');
        span.textContent = m[0];
        frag.appendChild(span);
        rest = rest.slice(idx + m[0].length);
      }
      if (rest) frag.appendChild(document.createTextNode(rest));
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  var observer = null;

  /* Never disconnects. Writes happen only when a value actually changes,
     so render passes triggered by our own mutations settle with no writes
     and the observer loop dies out on its own. */
  function render() {
    wrapMoneyNodes(document.body);
    var spans = document.querySelectorAll('.rhp-money');
    for (var i = 0; i < spans.length; i++) {
      var s = spans[i];
      var ngn = parseFloat(s.getAttribute('data-ngn'));
      if (isNaN(ngn)) continue;
      var next = formatMoney(ngn, state.currency, s.getAttribute('data-suffix') === '1');
      if (s.textContent !== next) s.textContent = next;
    }
    updateSwitcherLabel();
  }

  var renderQueued = false;
  function queueRender() {
    if (renderQueued) return;
    renderQueued = true;
    setTimeout(function () { renderQueued = false; render(); }, 150);
  }

  function startObserver() {
    if (observer) return;
    observer = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.nodeType === 1 && t.closest && t.closest('.rhp-cur')) continue;
        queueRender();
        return;
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  /* Switcher UI */
  function updateSwitcherLabel() {
    var label = document.querySelector('.rhp-cur__code');
    if (label && label.textContent !== state.currency) label.textContent = state.currency;
    var options = document.querySelectorAll('.rhp-cur__opt');
    for (var i = 0; i < options.length; i++) {
      options[i].setAttribute('aria-selected', options[i].getAttribute('data-code') === state.currency ? 'true' : 'false');
    }
  }

  function setCurrency(code) {
    if (!CURRENCIES[code]) return;
    state.currency = code;
    try { localStorage.setItem(STORE_KEY, code); } catch (e) {}
    render();
  }

  function initSwitcher() {
    var root = document.querySelector('.rhp-cur');
    if (!root) return;
    var toggle = root.querySelector('.rhp-cur__toggle');
    var menu = root.querySelector('.rhp-cur__menu');

    function close() { root.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); }
    function open() { root.classList.add('is-open'); toggle.setAttribute('aria-expanded', 'true'); }

    toggle.addEventListener('click', function () {
      root.classList.contains('is-open') ? close() : open();
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    menu.addEventListener('click', function (e) {
      var btn = e.target.closest('.rhp-cur__opt');
      if (!btn) return;
      setCurrency(btn.getAttribute('data-code'));
      close();
    });
  }

  function start() {
    state.currency = detectCurrency();
    initSwitcher();
    startObserver();
    loadRates(function () { render(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.rhpCurrency = { set: setCurrency, get: function () { return state.currency; }, rates: function () { return state.rates; } };
})();
